module.exports = __webpack_public_path__ + "img/hospital-bed-bw.de419471.jpg";